<template>
  <div class="cc-address-delivery">
    <div class="cc-address-delivery__header">
      <div class="cc-address-delivery__title cc-title cc-title--section px-0">{{ addressDeliveryTitle }}</div>
      <a class="cc-address-delivery__link cc-link" v-if="!isUserLoggedIn && display && allowLoginForm" @click="toggleLogin">{{ translations['Sign in'] }}</a>
    </div>
    <div class="cc-address-delivery__login" v-if="!isUserLoggedIn && display">
      <login :isUserLoginFormShown="isUserLoginFormShown"/>
    </div>
    <div class="cc-address-delivery__main cc-address-delivery__wrapper" v-if="display">
      <form>
        <div class="cc-grid">
          <div class="cc-grid__row">
            <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6 cc-grid__offset-right-desktop--6" v-if="config.is_user_logged && config.delivery_address_selector && customerAddresses.length > 1">
              <div class="cc-deliveryAddress--addresses cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <select
                    id="deliveryAddress.address"
                    class="cc-input cc-input--select cc-input--full-width"
                    autocomplete="off"
                    @change="fillDeliveryAddress"
                >
                  <option value="">{{ translations['Select delivery address'] }}</option>
                  <option v-for="address in customerAddresses" v-bind:key="address.id_address" :value="address.id_address">{{ address.alias }} </option>
                </select>
              </div>
            </div>
            <div class="cc-grid__col-mobile--12" v-bind:class="{'cc-grid__col-desktop--6': !pickupInStore, 'cc-grid__offset-right-desktop--6': !pickupInStore && !config.optional_address_fields.delivery_address.show_company,'cc-grid__col-desktop--12': pickupInStore}">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="deliveryAddress.email" type="email" name="deliveryAddress.email" class="smartform-email cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.email}" :disabled="isUserLoggedIn" :value="user.deliveryAddress.email" :placeholder="`${translations['E-mail']}*`" autocomplete="off" @change="updateEmail">
                <label for="deliveryAddress.email" class="cc-label cc-label--text">{{ translations['Email'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.email">{{ user.errors.deliveryAddress.email }}</div>
            </div>
            <div v-if="config.optional_address_fields.delivery_address.show_company" class="cc-grid__col-mobile--12" v-bind:class="{'cc-grid__col-desktop--6': !pickupInStore, 'cc-grid__col-desktop--12': pickupInStore}">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="deliveryAddress.company" type="text" name="deliveryAddress.company" class="cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.company}" :value="user.deliveryAddress.company" :placeholder="deliveryCompanyPlaceholder" autocomplete="off" @change="updateCompany">
                <label for="deliveryAddress.company" class="cc-label cc-label--text">{{ translations['Company'] }}<span v-if="!config.optional_address_fields.delivery_address.company">*</span></label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.company">{{ user.errors.deliveryAddress.company }}</div>
            </div>
            <div class="cc-grid__col-mobile--6" v-bind:class="{'cc-grid__col-desktop--6': !pickupInStore, 'cc-grid__col-desktop--12': pickupInStore}">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="deliveryAddress.firstname" type="text" name="deliveryAddress.firstname" class="cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.firstname}" :value="user.deliveryAddress.firstname" :placeholder="`${translations['Firstname']}*`" autocomplete="off" @change="updateFirstname">
                <label for="deliveryAddress.firstname" class="cc-label cc-label--text">{{ translations['Firstname'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.firstname">{{ user.errors.deliveryAddress.firstname }}</div>
            </div>
            <div class="cc-grid__col-mobile--6" v-bind:class="{'cc-grid__col-desktop--6': !pickupInStore, 'cc-grid__col-desktop--12': pickupInStore}">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="deliveryAddress.lastname" type="text" name="deliveryAddress.lastname" class="cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.lastname}" :value="user.deliveryAddress.lastname" :placeholder="`${translations['Lastname']}*`" autocomplete="off" @change="updateLastname">
                <label for="deliveryAddress.lastname" class="cc-label cc-label--text">{{ translations['Lastname'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.lastname">{{ user.errors.deliveryAddress.lastname }}</div>
            </div>
            <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6" v-if="!pickupInStore">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="deliveryAddress.addressLine1" type="text" name="deliveryAddress.addressLine1" class="smartform-address-street-and-number cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.addressLine1}" :value="user.deliveryAddress.addressLine1" :placeholder="`${translations['Address']}*`" autocomplete="off" @change="updateAddressLine1">
                <label for="deliveryAddress.addressLine1" class="cc-label cc-label--text">{{ translations['Address'] }}*</label>
              </div>



              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.addressLine1">{{ user.errors.deliveryAddress.addressLine1 }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6" v-if="!pickupInStore">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <the-mask :disabled="isPostalCodeLocked" v-if="postalCodeMask" id="deliveryAddress.postalCode" type="text" name="deliveryAddress.postalCode" class="smartform-address-zip cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.postalCode}" :value="user.deliveryAddress.postalCode" :placeholder="`${translations['Postal code']}*`" :mask="postalCodeMask" autocomplete="off" @change.native="updatePostalCode"/>
                <input :disabled="isPostalCodeLocked" v-if="!postalCodeMask" id="deliveryAddress.postalCode" type="text" name="deliveryAddress.postalCode" class="smartform-address-zip cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.postalCode}" :value="user.deliveryAddress.postalCode" :placeholder="`${translations['Postal code']}*`" autocomplete="off" @change="updatePostalCode">
                <label for="deliveryAddress.postalCode" class="cc-label cc-label--text">{{ translations['Postal code'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.postalCode">{{ user.errors.deliveryAddress.postalCode }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6" v-if="!pickupInStore">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="deliveryAddress.city" type="text" name="deliveryAddress.city" class="smartform-address-city cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.deliveryAddress.city}" :value="user.deliveryAddress.city" :placeholder="`${translations['City']}*`" autocomplete="off" @change="updateCity">
                <label for="deliveryAddress.city" class="cc-label cc-label--text">{{ translations['City'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.city">{{ user.errors.deliveryAddress.city }}</div>
            </div>
            <div class="cc-grid__col-mobile--12 cc-grid__col__phone-prefix" v-bind:class="{'cc-grid__col-desktop--6': !pickupInStore, 'cc-grid__col-desktop--12': pickupInStore}">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <select
                  id="deliveryAddress.phonePrefix"
                  class="cc-input cc-input--select cc-input--full-width"
                  autocomplete="off"
                  @change="fillDeliveryAddressPhonePrefix"
                  :value="user.deliveryAddress.phonePrefix"
                >
                  <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.tel_prefix }}</option>
                </select>
              </div>
            </div>
            <div class="cc-grid__col-mobile--12 cc-grid__col__phone" v-bind:class="{'cc-grid__col-desktop--6': !pickupInStore, 'cc-grid__col-desktop--12': pickupInStore}">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="deliveryAddress.phone"
                       v-mask="phoneDeliveryMask"
                       :placeholder="`${translations['Phone']}*`"
                       :value="user.deliveryAddress.phone"
                       autocomplete="off"
                       class="cc-input cc-input--text cc-input--full-width"
                       name="deliveryAddress.phone"
                       type="text"
                       v-bind:class="{'cc-invalid': user.errors.deliveryAddress.phone}"
                       @change="updatePhone">
                <label for="deliveryAddress.phone" class="cc-label cc-label--text">{{ translations['Phone'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.deliveryAddress.phone">{{ user.errors.deliveryAddress.phone }}</div>
            </div>
            <div v-if="config.phone_delivery_information_text_active" class="cc-grid__col-desktop--6"></div>
            <div v-if="config.phone_delivery_information_text_active" class="cc-grid__col-mobile--12 cc-grid__col-desktop--6">
              <div class="cc-form-element cc-form-element--with-top-margin">
                <div class="cc-alert cc-alert--information cc-alert--margin-top">{{ translations['Information required for delivery by carrier'] }}</div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="cc-addresses__controls mt-1" v-if="display && themeSettings.allow_invoice_address">
      <div class="cc-grid">
        <div class="cc-grid__row">
          <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6">
            <div class="cc-form-element cc-form-element--with-top-margin">
              <input id="user_invoiceAddress" type="checkbox" name="user.invoiceAddress" class="cc-input cc-input--checkbox" :checked="user.differentInvoiceAddress" autocomplete="off" @change="toggleInvoiceAddress">
              <label for="user_invoiceAddress" class="cc-label cc-label--checkbox"> {{ translations['I want an invoice'] }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="cc-grid cc-address-invoice__wrapper" v-if="user.differentInvoiceAddress">
        <div class="cc-address-invoice__header">
          <div class="cc-address-invoice__title cc-title cc-title--section col-12 px-0">{{ translations['Invoice address'] }}</div>
        </div>
        <form>
          <div class="cc-grid__row">
            <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6 cc-grid__offset-right-desktop--6" v-if="config.is_user_logged && config.invoice_address_selector && customerAddresses.length > 1">
              <div class="cc-invoiceAddress--addresses cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <select
                    id="invoiceAddress.address"
                    class="cc-input cc-input--select cc-input--full-width"
                    autocomplete="off"
                    @change="fillInvoiceAddress"
                >
                  <option value="">{{ translations['Select invoice address'] }}</option>
                  <option v-for="address in customerAddresses" v-bind:key="address.id_address" :value="address.id_address">{{ address.alias }} </option>
                </select>
              </div>
            </div>
            <div
              class="cc-grid__col-mobile--12 cc-grid__col-desktop--6 "
              :class="{'cc-grid__offset-right-desktop--6': invoiceStates.length === 0}"
          >
              <div class="cc-invoiceAddress--country cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <select
                    id="invoiceAddress.country"
                    :class="{'cc-invalid': user.errors.invoiceAddress.country}"
                    :placeholder="`${translations['Country']}*`"
                    :value="user.invoiceAddress.country"
                    class="cc-input cc-input--select cc-input--full-width"
                    name="invoiceAddress.country"
                    autocomplete="off"
                    @change="updateInvoiceCountry"
                >
                  <option value="" disabled="disabled">{{ translations['Select country'] }}</option>
                  <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.name }}</option>
                </select>
                <label for="invoiceAddress.country" class="cc-label cc-label--text">{{ translations['Country'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.country">{{ user.errors.invoiceAddress.country }}</div>
          </div>
          <div v-if="invoiceStates.length > 0" class="cc-grid__col-mobile--12 cc-grid__col-desktop--6">
            <div class="cc-invoiceAddress--country cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
              <select
                  id="invoiceAddress.state"
                  :class="{'cc-invalid': user.errors.invoiceAddress.state}"
                  :placeholder="`${translations['State']}*`"
                  :value="user.invoiceAddress.state"
                  class="cc-input cc-input--select cc-input--full-width"
                  name="invoiceAddress.state"
                  autocomplete="off"
                  @change="updateInvoiceState"
              >
                <option value="0" disabled="disabled">{{ translations['Select state'] }}</option>
                <option v-for="state in invoiceStates" v-bind:key="state.id_state" :value="state.id_state">{{ state.name }}</option>
              </select>
              <label for="invoiceAddress.country" class="cc-label cc-label--text">{{ translations['State'] }}*</label>
            </div>
            <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.state">{{ user.errors.invoiceAddress.state }}</div>
            </div>
            <div class="cc-grid__col-mobile--6"
                 :class="{'cc-grid__col-desktop--3': this.modules.shaim_ares !== undefined, 'cc-grid__col-desktop--6': this.modules.shaim_ares === undefined || parseInt(user.invoiceAddress.country) !== 16}">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input
                    id="invoiceAddress.identificationNumber"
                    :placeholder="invoiceIdentificationNumberInputName"
                    :value="user.invoiceAddress.identificationNumber"
                    class="cc-input cc-input--text cc-input--full-width"
                    name="invoiceAddress.identificationNumber"
                    type="text"
                    v-bind:class="{'cc-invalid': user.errors.invoiceAddress.identificationNumber}"
                    autocomplete="off"
                    @change="updateInvoiceIdentificationNumber"
                >
                <label for="invoiceAddress.identificationNumber" class="cc-label cc-label--text">
                  {{ invoiceIdentificationNumberInputName }}
                </label>
              </div>
              <div
                  v-if="user.errors.invoiceAddress.identificationNumber"
                  class="cc-alert cc-alert--error cc-alert--margin-top"
              >{{ user.errors.invoiceAddress.identificationNumber }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--3" v-if="this.modules.shaim_ares !== undefined && parseInt(user.invoiceAddress.country) === 16">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <shaim-ares-button/>
              </div>
            </div>
            <div class="cc-grid__col-desktop--6"
                 :class="{'cc-grid__col-mobile--12': this.modules.shaim_ares !== undefined && parseInt(user.invoiceAddress.country) === 16, 'cc-grid__col-mobile--6': this.modules.shaim_ares === undefined || parseInt(user.invoiceAddress.country) !== 16}"
            >
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input
                    id="invoiceAddress.taxIdentificationNumber"
                    :placeholder="invoiceTaxIdentificationNumberInputName" :value="user.invoiceAddress.taxIdentificationNumber"
                    class="cc-input cc-input--text cc-input--full-width"
                    name="invoiceAddress.taxIdentificationNumber"
                    type="text"
                    v-bind:class="{'cc-invalid': user.errors.invoiceAddress.taxIdentificationNumber || user.invoiceAddress.taxIdentificationNumberState === 'vies_invalid'}"
                    autocomplete="off"
                    @change="updateInvoiceTaxIdentificationNumber"
                >
                <label for="invoiceAddress.taxIdentificationNumber" class="cc-label cc-label--text">
                  {{ invoiceTaxIdentificationNumberInputName }} <i v-if="user.invoiceAddress.taxIdentificationNumberState === 'loading'" class="fa fa-spinner fa-spin"></i>
                </label>
              </div>
              <div
                  v-if="user.invoiceAddress.taxIdentificationNumberState === 'vies_valid' || user.invoiceAddress.taxIdentificationNumberState === 'vies_valid_with_tax'"
                  class="cc-alert cc-alert--success cc-alert--margin-top"
              >{{ translations['Tax identification number is valid'] }}</div>
              <div
                  v-if="user.invoiceAddress.taxIdentificationNumberState === 'vies_invalid'"
                  class="cc-alert cc-alert--error cc-alert--margin-top"
              >{{ translations['Tax identification number is invalid'] }}</div>
              <div
                  v-if="user.errors.invoiceAddress.taxIdentificationNumber && user.invoiceAddress.taxIdentificationNumberState === ''"
                  class="cc-alert cc-alert--error cc-alert--margin-top"
              >{{ user.errors.invoiceAddress.taxIdentificationNumber }}</div>
            </div>
            <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input
                    id="invoiceAddress.company"
                    :class="{'cc-invalid': user.errors.invoiceAddress.company}"
                    :placeholder="invoiceCompanyInputName"
                    :value="user.invoiceAddress.company"
                    class="cc-input cc-input--text cc-input--full-width"
                    name="invoiceAddress.company"
                    type="text"
                    autocomplete="off"
                    @change="updateInvoiceCompany"
                > <label for="invoiceAddress.company" class="cc-label cc-label--text">{{ invoiceCompanyInputName }}</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.company">{{ user.errors.invoiceAddress.company }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="invoiceAddress.firstname" type="text" name="invoiceAddress.firstname" class="cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.firstname}" :value="user.invoiceAddress.firstname" :placeholder="`${invoiceFirstname}`" autocomplete="off" @change="updateInvoiceFirstname">
                <label for="invoiceAddress.firstname" class="cc-label cc-label--text">{{ invoiceFirstname }}</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.firstname">{{ user.errors.invoiceAddress.firstname }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="invoiceAddress.lastname" type="text" name="invoiceAddress.lastname" class="cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.lastname}" :value="user.invoiceAddress.lastname" :placeholder="`${invoiceLastname}`" autocomplete="off" @change="updateInvoiceLastname">
                <label for="invoiceAddress.lastname" class="cc-label cc-label--text">{{ invoiceLastname }}</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.lastname">{{ user.errors.invoiceAddress.lastname }}</div>
            </div>
            <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="invoiceAddress.addressLine1" type="text" name="invoiceAddress.addressLine1" class="smartform-address-street-and-number cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.addressLine1}" :value="user.invoiceAddress.addressLine1" :placeholder="`${translations['Address']}*`" autocomplete="off" @change="updateInvoiceAddressLine1">
                <label for="invoiceAddress.addressLine1" class="cc-label cc-label--text">{{ translations['Address'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.addressLine1">{{ user.errors.invoiceAddress.addressLine1 }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <the-mask v-if="invoicePostalCodeMask" id="invoiceAddress.postalCode" type="text" name="invoiceAddress.postalCode" class="smartform-address-zip cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.postalCode}" :value="user.invoiceAddress.postalCode" :placeholder="`${translations['Postal code']}*`" :mask="invoicePostalCodeMask" autocomplete="off" @displayValue="updateInvoicePostalCodeWithValue" />
                <input v-if="!invoicePostalCodeMask" id="invoiceAddress.postalCode" type="text" name="invoiceAddress.postalCode" class="smartform-address-zip cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.postalCode}" :value="user.invoiceAddress.postalCode" :placeholder="`${translations['Postal code']}*`" autocomplete="off" @change="updateInvoicePostalCode">
                <label for="invoiceAddress.postalCode" class="cc-label cc-label--text">{{ translations['Postal code'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.postalCode">{{ user.errors.invoiceAddress.postalCode }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="invoiceAddress.city" type="text" name="invoiceAddress.city" class="smartform-address-city cc-input cc-input--text cc-input--full-width" v-bind:class="{'cc-invalid': user.errors.invoiceAddress.city}" :value="user.invoiceAddress.city" :placeholder="`${translations['City']}*`" autocomplete="off" @change="updateInvoiceCity">
                <label for="invoiceAddress.city" class="cc-label cc-label--text">{{ translations['City'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.city">{{ user.errors.invoiceAddress.city }}</div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6 cc-grid__col__phone-prefix">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <select
                    id="invoiceAddress.phonePrefix"
                    class="cc-input cc-input--select cc-input--full-width"
                    autocomplete="off"
                    @change="fillInvoiceAddressPhonePrefix"
                    :value="user.invoiceAddress.phonePrefix"
                >
                  <option v-for="country in countries" v-bind:key="country.id" :value="country.id">{{ country.tel_prefix }}</option>
                </select>
              </div>
            </div>
            <div class="cc-grid__col-mobile--6 cc-grid__col-desktop--6 cc-grid__col__phone">
              <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
                <input id="invoiceAddress.phone"
                       v-mask="phoneInvoiceMask"
                       :placeholder="`${translations['Phone']}*`"
                       :value="user.invoiceAddress.phone"
                       autocomplete="off"
                       class="cc-input cc-input--text cc-input--full-width"
                       name="invoiceAddress.phone"
                       type="text"
                       v-bind:class="{'cc-invalid': user.errors.invoiceAddress.phone}"
                       @change="updateInvoicePhone">
                <label for="invoiceAddress.phone" class="cc-label cc-label--text">{{ translations['Phone'] }}*</label>
              </div>
              <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.invoiceAddress.phone">{{ user.errors.invoiceAddress.phone }}</div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="cc-addresses__controls" v-if="display && allowRegistrationForm">
      <div class="cc-form-element cc-form-element--with-top-margin" v-if="!isUserLoggedIn">
        <input id="user_requestRegistration" type="checkbox" name="user.requestRegistration" class="cc-input cc-input--checkbox" :checked="user.requestRegistration" autocomplete="off" @change="toggleRequestRegistration">
        <label for="user_requestRegistration" class="cc-label cc-label--checkbox">{{ translations['Request registration'] }}</label>
        <div v-if="config.theme_settings.registration_info" :title="config.theme_settings.registration_info" class="registration-info"><span>i</span></div>
      </div>
      <div class="cc-grid" v-if="user.requestRegistration">
        <div class="cc-grid__row">
          <div class="cc-grid__col-mobile--12 cc-grid__col-desktop--6">
            <div class="cc-form-element cc-form-element--with-floating-label cc-form-element--with-top-margin">
              <input id="user.password" type="password" name="user.password" class="cc-input cc-input--text cc-input--full-width" :value="user.password" :placeholder="`${translations['Password']}*`" autocomplete="off" @change="updatePassword">
              <label for="user.password" class="cc-label cc-label--text">{{ translations['Password'] }}*</label>
            </div>
            <div class="cc-alert cc-alert--error cc-alert--margin-top" v-if="user.errors.password">{{ user.errors.password }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="cc-address-delivery__alerts" v-if="!display">
      <div class="cc-alert cc-alert--information">{{ translations['Please select payment to show delivery information'] }}</div>
    </div>
    <div class="cc-addresses__controls">
      <div class="cc-form-element cc-form-element--with-top-margin marked-data">
        {{ translations['* Data marked as such must be filled in'] }}
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import TheMask from "@/components/_common/TheMask/TheMask";

import Login from "./Login";
import AddressSelect from "@/components/Store919/AddressSelect";
import ShaimAresButton from "@/components/_common/modules/shaim_ares/ShaimAresButton";

export default {
  components: {
    TheMask,
    Login,
    AddressSelect,
    ShaimAresButton
  },
  watch: {
    display(val) {
      if (window.smartform && val !== null) {
        this.reinitializeSmartForm();
      }
    },
    "user.differentInvoiceAddress": function (val) {
      if (window.smartform && val) {
        this.reinitializeSmartForm();
      }
      this.fillStates();
    },
    "user.invoiceAddress.country": function (val) {
      this.fillStates();
    },
  },
  computed: {
    ...mapState({
      translations: state => state.translations,
      config: state => state.config,
      currentCarrier: state => state.currentCarrier,
      isUserLoggedIn: state => state.isLoggedIn,
      user: state => state.user,
      selectedCarrier: state => state.selectedCarrier,
      selectedPayment: state => state.selectedPayment,
      countries: state => state.config.countries,
      optionalAddressFields: state => state.config.optional_address_fields,
      themeSettings: state => state.config.theme_settings,
      modules: state => state.config.modules,
      allowLoginForm: state => state.config.allow_login_in_cart,
      allowRegistrationForm: state => state.config.allow_registration_in_cart,
      isPostalCodeLocked: state => state.lockDeliveryPostalCode,
      selectedCountry: state => state.user.deliveryAddress.country
    }),
    ...mapGetters({
      hasUserErrors: getter => getter.hasUserErrors,
    }),
    display: function () {
      return this.user.deliveryAddress.country && this.selectedCarrier && this.selectedPayment;
    },
    pickupInStore: function () {
      return this.currentCarrier && this.currentCarrier.pickupInStore;
    },
    addressDeliveryTitle: function () {
      return this.pickupInStore ? this.translations['Contact details'] : this.translations['Delivery address'];
    },
    shouldPasswordBeShown: function () {
      return !this.isUserLoggedIn && this.user.requestRegistration;
    },
    countryName: function () {
      for (let key in this.countries) {
        if (!this.countries.hasOwnProperty(key)) {
          continue;
        }

        if (this.countries[key].id === this.user.deliveryAddress.country) {
          return this.countries[key].name;
        }
      }

      return '';
    },
    postalCodeMask: function () {
      for (let key in this.countries) {
        if (!this.countries.hasOwnProperty(key)) {
          continue;
        }

        if (parseInt(this.countries[key].id) === parseInt(this.user.deliveryAddress.country)) {
          return this.countries[key].zip_format;
        }
      }

      return null;
    },
    phoneDeliveryMask: function () {
      for (let key in this.countries) {
        if (!this.countries.hasOwnProperty(key)) {
          continue;
        }

        if (parseInt(this.countries[key].id) === parseInt(this.user.deliveryAddress.phonePrefix)) {
          return this.countries[key].tel_format;
        }
      }

      return null;
    },
    phoneInvoiceMask: function () {
      for (let key in this.countries) {
        if (!this.countries.hasOwnProperty(key)) {
          continue;
        }

        if (parseInt(this.countries[key].id) === parseInt(this.user.invoiceAddress.phonePrefix)) {
          return this.countries[key].tel_format;
        }
      }

      return null;
    },
    invoicePostalCodeMask: function () {
      for (let key in this.countries) {
        if (!this.countries.hasOwnProperty(key)) {
          continue;
        }

        if (parseInt(this.countries[key].id) === parseInt(this.user.invoiceAddress.country)) {
          return this.countries[key].zip_format;
        }
      }

      return null;
    },
    // input names
    invoiceFirstname: function () {
      if (this.optionalAddressFields.invoice_address.first_name === '1') {
        return this.translations['Firstname'];
      }
      return this.translations['Firstname'] + '*';
    },
    invoiceLastname: function () {
      if (this.optionalAddressFields.invoice_address.last_name === '1') {
        return this.translations['Lastname'];
      }
      return this.translations['Lastname'] + '*';
    },
    invoiceCompanyInputName: function () {
      if (this.optionalAddressFields.invoice_address.company === '1') {
        return this.translations['Company'];
      }
      return this.translations['Company'] + '*';
    },
    invoicePhoneInputName: function () {
      if (this.optionalAddressFields.invoice_address.phone === '1') {
        return this.translations['Phone'];
      }
      return this.translations['Phone'] + '*';
    },
    invoiceIdentificationNumberInputName: function () {
      if (this.optionalAddressFields.invoice_address.identification_number === '1') {
        return this.translations['Identification number'];
      }
      return this.translations['Identification number'] + '*';
    },
    invoiceTaxIdentificationNumberInputName: function () {
      if (this.optionalAddressFields.invoice_address.tax_identification_number === '1') {
        return this.translations['Tax identification number'];
      }
      return this.translations['Tax identification number'] + '*';
    },
    customerAddresses: function () {
      return this.user.addresses.filter((item) => {
        if (parseInt(item.id_customer) === 0) {
          return false;
        }

        return true;
      })
    },
    deliveryCompanyPlaceholder: function () {
      if (this.optionalAddressFields.delivery_address.company === '1') {
        return this.translations['Company'];
      }
      return this.translations['Company'] + '*';
    }
  },
  data: function () {
    return {
      isUserLoginFormShown: false,
      addressLoading: false,
      invoiceStates: [],
    };
  },
  mounted: function () {
    this.$store.state.user.deliveryAddress.phonePrefix = this.$store.state.user.deliveryAddress.country ? this.$store.state.user.deliveryAddress.country : this.selectedCountry;
    this.$store.state.user.invoiceAddress.phonePrefix = this.$store.state.user.invoiceAddress.country ? this.$store.state.user.invoiceAddress.country : this.selectedCountry;
  },
  methods: {
    fillStates: function () {
      let selectedCountry = this.countries.find(function (country) {
        return parseInt(country.id) === parseInt(this.user.invoiceAddress.country)
      }.bind(this));
      if (!selectedCountry) {
        this.invoiceStates = [];
        return;
      }
      if (!selectedCountry.states) {
        this.invoiceStates = [];
        return;
      }
      this.invoiceStates = selectedCountry.states
    },
    reinitializeSmartForm: function () {
      var that = this;
      setTimeout(() => {
        window.smartform.rebindAllForms(function () {
          window.smartform.getInstance().addressControl.setSelectionCallback(function (input, value, type) {
            if (input.id === 'deliveryAddress.addressLine1') {
              that.updateAddressLine1({ target: { value: value }});
            }
            if (input.id === 'deliveryAddress.city') {
              that.updateCity({ target: { value: value }});
            }
            if (input.id === 'deliveryAddress.postalCode') {
              that.updatePostalCode({ target: { value: value }});
            }

            if (input.id === 'invoiceAddress.addressLine1') {
              that.updateInvoiceAddressLine1({ target: { value: value }});
            }
            if (input.id === 'invoiceAddress.city') {
              that.updateInvoiceCity({ target: { value: value }});
            }
            if (input.id === 'invoiceAddress.postalCode') {
              that.updateInvoicePostalCode({ target: { value: value }});
            }
          })
        });
      }, 100);
    },
    toggleLogin: function () {
      this.isUserLoginFormShown = !this.isUserLoginFormShown;
    },
    toggleRequestRegistration: function (event) {
      const requestRegistration = event.target.checked;

      if (!requestRegistration) {
        this.$store.commit('SET_USER_PASSWORD', '');
        this.$store.commit('SET_USER_PASSWORD_ERROR', '');
      }

      this.$store.commit('SET_USER_REQUEST_REGISTRATION', requestRegistration);
    },
    toggleInvoiceAddress: function (event) {
      const showInvoiceAddress = event.target.checked;
      this.$store.dispatch('UPDATE_USER_DIFFERENT_INVOICE_ADDRESS', showInvoiceAddress)
          .then(() => {
            this.fillStates();
          })
    },
    updatePassword: function (event) {
      this.$store.dispatch('UPDATE_PASSWORD', event.target.value);
    },
    updateEmail: function (event) {
      this.$store.dispatch('UPDATE_EMAIL', event.target.value);
    },
    updateCompany: function (event) {
      this.$store.dispatch('UPDATE_COMPANY', event.target.value);
    },
    updateFirstname: function (event) {
      this.$store.dispatch('UPDATE_FIRSTNAME', event.target.value);
    },
    updateLastname: function (event) {
      this.$store.dispatch('UPDATE_LASTNAME', event.target.value);
    },
    updateAddressLine1: function (event) {
      this.$store.dispatch('UPDATE_ADDRESS_LINE_1', event.target.value);
    },
    updatePostalCode: function (event) {
      this.$store.dispatch('UPDATE_POSTAL_CODE', event.target.value);
    },
    updateCity: function (event) {
      this.$store.dispatch('UPDATE_CITY', event.target.value);
    },
    updatePhone: function (event) {
      this.$store.dispatch('UPDATE_PHONE', event.target.value);
    },
    updateInvoiceCompany: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_COMPANY', event.target.value);
    },
    updateInvoiceFirstname: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_FIRSTNAME', event.target.value);
    },
    updateInvoiceLastname: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_LASTNAME', event.target.value);
    },
    updateInvoiceAddressLine1: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_ADDRESS_LINE_1', event.target.value);
    },
    updateInvoicePostalCodeWithValue: function (value) {
      this.$store.dispatch('UPDATE_INVOICE_POSTAL_CODE', value);
    },
    updateInvoicePostalCode: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_POSTAL_CODE', event.target.value);
    },
    updateInvoiceCountry: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_COUNTRY', event.target.value)
          .then(() => {
            this.fillStates()
          })
    },
    updateInvoiceState: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_STATE', event.target.value);
      this.$store.state.user.invoiceAddress.phonePrefix = event.target.value;
    },
    updateInvoiceCity: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_CITY', event.target.value);
    },
    updateInvoicePhone: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_PHONE', event.target.value);
    },
    updateInvoiceIdentificationNumber: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_IDENTIFICATION_NUMBER', event.target.value);
    },
    updateInvoiceTaxIdentificationNumber: function (event) {
      this.$store.dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', event.target.value);
    },
    updateDeliveryAddress: function (id) {
      this.$store.dispatch('UPDATE_DELIVERY_ADDRESS_BY_ID', id)
    },
    updateInvoiceAddress: function (id) {
      this.$store.dispatch('UPDATE_INVOICE_ADDRESS_BY_ID', id)
    },
    fillInvoiceAddress: function (e) {
      e.preventDefault();
      const id = e.target.value;
      if (!id) {
        return;
      }
      this.addressLoading = true;
      this.showInvoiceLoading();
      this.$store.dispatch('UPDATE_INVOICE_ADDRESS_BY_ID', id)
          .then(() => {
            const address = this.user.addresses.filter(item => parseInt(item.id_address) === parseInt(id))[0];

            this.$store.state.user.invoiceAddress.phonePrefix = parseInt(address.id_country);
            this.$store.dispatch('UPDATE_INVOICE_ADDRESS_PHONE_PREFIX', parseInt(address.id_country));

            this.fillStates();
            this.addressLoading = false;
            this.hideInvoiceLoading();
          })
    },
    fillDeliveryAddress: function (e) {
      e.preventDefault();
      const id = e.target.value;
      if (!id) {
        return;
      }
      this.addressLoading = true;
      this.showDeliveryLoading();
      const originalCountry = this.user.deliveryAddress.country;
      this.$store.dispatch('UPDATE_DELIVERY_ADDRESS_BY_ID', id)
          .then(() => {
            this.fillStates();
            const address = this.user.addresses.filter(item => parseInt(item.id_address) === parseInt(id))[0];
            if (parseInt(address.id_country) !== parseInt(originalCountry)) {
              this.$store.commit('SET_ERROR_LOGIN_COUNTRY_MISMATCH', true);
            }

            this.$store.state.user.deliveryAddress.phonePrefix = parseInt(address.id_country);
            this.$store.dispatch('UPDATE_DELIVERY_ADDRESS_PHONE_PREFIX', parseInt(address.id_country));

            this.addressLoading = false;
            this.hideDeliveryLoading();
          })
    },
    fillDeliveryAddressPhonePrefix: function (e) {
      e.preventDefault();
      const id = e.target.value;
      if (!id) {
        return;
      }
      this.$store.state.user.deliveryAddress.phonePrefix = id;
      this.$store.dispatch('UPDATE_DELIVERY_ADDRESS_PHONE_PREFIX', id);
    },
    fillInvoiceAddressPhonePrefix: function (e) {
      e.preventDefault();
      const id = e.target.value;
      if (!id) {
        return;
      }
      this.$store.state.user.invoiceAddress.phonePrefix = id;
      this.$store.dispatch('UPDATE_INVOICE_ADDRESS_PHONE_PREFIX', id);
    },
    showInvoiceLoading: function () {
      const body = document.querySelector('.cc-address-invoice__wrapper');
      const coverSpin = document.createElement('div');
      coverSpin.id = 'cart-cover-spin';
      coverSpin.classList.add('cart-cover-spin-address-invoice')
      body.appendChild(coverSpin);
    },
    hideInvoiceLoading: function () {
      document.querySelector('.cart-cover-spin-address-invoice').remove();
    },
    showDeliveryLoading: function () {
      const body = document.querySelector('.cc-address-delivery__wrapper');
      const coverSpin = document.createElement('div');
      coverSpin.id = 'cart-cover-spin';
      coverSpin.classList.add('cart-cover-spin-address-delivery')
      body.appendChild(coverSpin);
    },
    hideDeliveryLoading: function () {
      document.querySelector('.cart-cover-spin-address-delivery').remove();
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "./scss/components/address-delivery";
.marked-data {
  font-size: .8rem;
  color: #808080;
}

.registration-info {
  background: #b7b7b7;
  border-radius: 24px;
  display: inline;
  padding: 6px;
  margin-left: 4px;
  span {
    width: 17px;
    display: inline-block;
    height: 12px;
    text-align: center;
    font-weight: bold;
    font-size: 19px;
    font-family: serif;
    color: white;
  }
}

.cc-grid__col__phone-prefix .cc-input--select {
  padding-left: 1rem;
}

.cc-grid__col__phone-prefix {
  flex: 0 0 50%;
}
.cc-grid__col__phone {
  flex: 0 0 50%;
}

@media screen and (min-width: 1199px) {
  .cc-grid__col__phone-prefix {
    flex: 0 0 21%;
  }
  .cc-grid__col__phone {
    flex: 0 0 29%;
  }
}

</style>
